// Sri Lanka 2026 full-moon Poya calendar (astronomical, local time).
// Names in Sinhala/English/Tamil/Hindi; short significance bilingual (si/en),
// with special reverence for Binara Poya and the Meheni Sasana.
export const POYA_2026 = [
  { date: "2026-01-03", key: "duruthu",
    name: { si: "දුරුතු පොහොය", en: "Duruthu Poya", ta: "துருது பௌயா", hi: "दुरुतु पोया" },
    sig: { si: "බුදුරජාණන් වහන්සේගේ පළමු ලංකා ගමනය සිහිකරයි.", en: "Marks the Buddha's first visit to Sri Lanka." } },
  { date: "2026-02-01", key: "navam",
    name: { si: "නවම් පොහොය", en: "Navam Poya", ta: "நவம் பௌயா", hi: "नवम् पोया" },
    sig: { si: "සැරියුත් මුගලන් අග්‍රශ්‍රාවකයන් පත් වූ දිනය.", en: "The appointing of the two chief disciples, Sariputta and Moggallana." } },
  { date: "2026-03-02", key: "medin",
    name: { si: "මැදින් පොහොය", en: "Medin Poya", ta: "மெதின் பௌயா", hi: "मेदिन् पोया" },
    sig: { si: "බුදුරජාණන් වහන්සේ පියරජු සුද්ධෝදන රජුට දහම් දෙසූ දිනය.", en: "The Buddha's visit to his father King Suddhodana." } },
  { date: "2026-04-01", key: "bak",
    name: { si: "බක් පොහොය", en: "Bak Poya", ta: "பக் பௌயா", hi: "बक् पोया" },
    sig: { si: "බුදුරජාණන් වහන්සේගේ දෙවන ලංකා ගමනය සිහිකරයි.", en: "Marks the Buddha's second visit to Sri Lanka." } },
  { date: "2026-05-01", key: "adhi-vesak",
    name: { si: "අධි වෙසක් පොහොය", en: "Adhi Vesak Poya", ta: "அதி வெசாக் பௌயா", hi: "अधि वेसाक पोया" },
    sig: { si: "අධික මාසයේ පුර පසළොස්වක.", en: "The full moon of the intercalary month." } },
  { date: "2026-05-30", key: "vesak",
    name: { si: "වෙසක් පොහොය", en: "Vesak Poya", ta: "வெசாக் பௌயா", hi: "वेसाक पोया" },
    sig: { si: "බුදුරජාණන් වහන්සේගේ උපත, බුද්ධත්වය සහ පරිනිර්වාණය.", en: "The Buddha's birth, enlightenment and passing away." } },
  { date: "2026-06-29", key: "poson",
    name: { si: "පොසොන් පොහොය", en: "Poson Poya", ta: "பொசொன் பௌயா", hi: "पोसोन पोया" },
    sig: { si: "මිහිඳු මහරහතන් වහන්සේ ලංකාවට බුදුදහම ගෙන ආ දිනය.", en: "Arahant Mahinda bringing Buddhism to Sri Lanka." } },
  { date: "2026-07-29", key: "esala",
    name: { si: "ඇසළ පොහොය", en: "Esala Poya", ta: "எசள பௌயா", hi: "एसल पोया" },
    sig: { si: "බුදුරජාණන් වහන්සේගේ ප්‍රථම ධර්මදේශනාව — දම්සක් පැවතුම් සූත්‍රය.", en: "The Buddha's first sermon, the Dhammacakkappavattana Sutta." } },
  { date: "2026-08-27", key: "nikini",
    name: { si: "නිකිණි පොහොය", en: "Nikini Poya", ta: "நிகிணி பௌயா", hi: "निकिणि पोया" },
    sig: { si: "පළමු ධර්ම සංගායනාව ආරම්භ වූ දිනය.", en: "Commemorates the start of the First Buddhist Council." } },
  { date: "2026-09-26", key: "binara",
    name: { si: "බිනර පොහොය", en: "Binara Poya", ta: "பினர பௌயா", hi: "बिनर पोया" },
    sig: {
      si: "මෙහෙණි සසුනේ ආරම්භය — මහා ප්‍රජාපතී ගෝතමියගේ ඉල්ලීමට බුදුරජාණන් වහන්සේ භික්ෂුණී සසුන පිහිටුවා, කාන්තාවන්ට ද විමුක්තියේ මඟ විවර කළ පූජනීය දිනය. පළමු ධර්ම සංගායනාව නිමා වූ දිනය ද වේ.",
      en: "The founding of the Bhikkhuni Sasana — at Maha Prajapati Gotami's request the Buddha established the order of nuns, opening the path to spiritual liberation equally for women. It also marks the conclusion of the First Buddhist Council.",
    },
    meheni: true },
  { date: "2026-10-25", key: "vap",
    name: { si: "වප් පොහොය", en: "Vap Poya", ta: "வப் பௌயா", hi: "वप् पोया" },
    sig: { si: "වස් කාලය නිමා වී කඨින චීවර පූජාව ආරම්භ වන දිනය.", en: "End of the rains retreat and the start of the Kathina season." } },
  { date: "2026-11-24", key: "il",
    name: { si: "ඉල් පොහොය", en: "Il Poya", ta: "இல் பௌயா", hi: "इल् पोया" },
    sig: { si: "රහතන් වහන්සේලා සැට නමක් ධර්මදූත කටයුතුවලට යැවූ දිනය.", en: "The Buddha dispatching sixty arahants to spread the Dhamma." } },
  { date: "2026-12-23", key: "unduvap",
    name: { si: "උඳුවප් පොහොය", en: "Unduvap Poya", ta: "உந்துவப் பௌயா", hi: "उन्दुवप् पोया" },
    sig: { si: "සංඝමිත්තා මහ රහත් තෙරණිය ජය ශ්‍රී මහා බෝ අංකුරය ලංකාවට ගෙන ආ දිනය.", en: "Sanghamitta Theri bringing the sacred Bo sapling to Sri Lanka." } },
];

function todayLocalStr() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

function diffDays(fromStr, toStr) {
  const a = new Date(fromStr + "T00:00:00");
  const b = new Date(toStr + "T00:00:00");
  return Math.round((b - a) / 86400000);
}

// Returns { poya, isEve } when today is a Poya day (or its eve), else null.
export function getTodayPoya() {
  const today = todayLocalStr();
  for (const p of POYA_2026) {
    const d = diffDays(today, p.date);
    if (d === 0) return { poya: p, isEve: false };
    if (d === 1) return { poya: p, isEve: true };
  }
  return null;
}

function _hash(str) { let h = 0; for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0; return h; }

// A calm "Sil day" playlist: prefers pirith/gatha/sil/poya/calm tags, day-stable order.
export function poyaPlaylist(songs) {
  if (!songs || !songs.length) return [];
  const pref = ["sil", "pirith", "gatha", "poya", "bana", "calm"];
  const picked = songs.filter((s) => (s.tags || []).some((t) => pref.includes(String(t).toLowerCase())));
  const base = picked.length ? picked : songs;
  const day = new Date().toDateString();
  return [...base]
    .map((s) => ({ s, k: _hash(s.id + day) }))
    .sort((a, b) => a.k - b.k)
    .slice(0, Math.min(10, base.length))
    .map((x) => x.s);
}

// Songs honouring women artists / nuns — tagged women/meheni/female.
export function meheniSongs(songs) {
  const tags = ["women", "meheni", "female", "bhikkhuni"];
  return (songs || []).filter((s) => (s.tags || []).some((t) => tags.includes(String(t).toLowerCase())));
}
